/** Decodes a JWT payload (browser-safe). UTF-8 safe for Hebrew and other non-ASCII claims. */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  try {
    const parts = token.split('.');
    if (parts.length < 2) {
      return null;
    }
    const json = base64UrlToUtf8String(parts[1]!);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

function base64UrlToUtf8String(base64Url: string): string {
  let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const pad = base64.length % 4;
  if (pad) {
    base64 += '='.repeat(4 - pad);
  }
  const binary = atob(base64);
  if (typeof TextDecoder !== 'undefined') {
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  }
  try {
    return decodeURIComponent(
      binary
        .split('')
        .map((char) => `%${(`00${char.charCodeAt(0).toString(16)}`).slice(-2)}`)
        .join(''),
    );
  } catch {
    return binary;
  }
}
